var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.582 7.155c-0.23-0.86583-0.9075-1.5483-1.7683-1.78-1.5592-0.42-7.8133-0.42-7.8133-0.42s-6.2542 0-7.8142 0.42001c-0.86 0.23166-1.5375 0.91332-1.7675 1.78-0.41833 1.57-0.41833 4.845-0.41833 4.845s0 3.275 0.41833 4.845c0.23 0.86584 0.9075 1.5483 1.7683 1.78 1.5592 0.42001 7.8133 0.42001 7.8133 0.42001s6.2542 0 7.8142-0.42001c0.86-0.23166 1.5375-0.91334 1.7683-1.78 0.4175-1.57 0.4175-4.845 0.4175-4.845s0-3.275-0.41833-4.845zm-11.627 7.8192v-5.9483l5.2267 2.9742z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d2f0779b0011ff698f3d58515e673d80.svg";
export { ForwardRef as ReactComponent };